import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

// import {CurrentsDataSourceComponent} from '../../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm, FormGroup, NgControl, NgModel } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SystemFile } from './../../../..//shared/models/file.model';
import { SubjectCommunicationAttatchments } from './../../../../shared/models/subjectCommunicationAttachments.model';
import { SubjectCommunication } from './../../../../shared/models/subjectCommunication.model';
import { Location } from '@angular/common';


// import { ToolbarService, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';
// import { isNullOrUndefined } from '@syncfusion/ej2-base';
import {
  MultiSelectComponent,
  DropDownListComponent,
} from '@syncfusion/ej2-angular-dropdowns';

// DocX - https://docx.js.org/#/?id=welcome
// import { Document, Packer, Paragraph, TextRun } from 'docx';

import * as $ from 'jquery';
// see: https://www.youtube.com/watch?v=YPBcy6LSxsg

import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection,
} from '@syncfusion/ej2-angular-richtexteditor';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';

@Component({
  selector: 'app-subject-documents-create-docx-merge-widget',
  templateUrl: './subject-documents-create-docx-merge-widget.component.html',
  styleUrls: ['./subject-documents-create-docx-merge-widget.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    MultiSelectComponent,
    DropDownListComponent,
  ],
})
export class SubjectDocumentsCreateDocxMergeWidgetComponent implements OnInit {

// setup as observable?
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

@Input() job_id?; // impliments on changes.
@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
@Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter();
@Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
@Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
@Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();
@Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();
@Output('refreshSujectWorkOrderPage') refreshSujectWorkOrderPage: EventEmitter<any> = new EventEmitter();


currentUserVAR: any;
sessionUserId: any;
sessionUserName: any;
sessionBrandId: any;
subject_id: number;
job_status_run: any;
subject_notes: any;
subjects: any;
public who;

bsModalRef: BsModalRef;
// MODAL
modalRef: BsModalRef;
subject_com_types: any;

feature = 'Feature 1';
selectedFeatures: any = [];
selectedFeaturesJobFiles: any = [];

allAttachedFiles: any = [];
allEmailRecipients: any = [];
allClientEmailRecipients: any = [];
allLoginEmailRecipients: any = [];
allClientInvoiceEmailRecipients: any = [];

// allAttachments: any[] = [];

// allAttachments: any[] = [];

allAttachments = [];

// as an angular object / model
/* allAttachments: any = {
file_name: 'testfilename.file',
job_file: 0 ,
subject_file: 0,
}; */
empList: Array<any> = [];

modelds: any;

public placeholder: String = 'All Recipients';

// toggle elements
isShow;
isShow_uploaded;

isDisabled;

email_template_directory = this.gfunc.baseUploadURLEmailTemplates;
// variables for richtexteditor as form
@ViewChild('fromRTE')
private rteEle: RichTextEditorComponent;

public tools: object = {
  items: [
    'Undo',
    'Redo',
    '|',
    'Bold',
    'Italic',
    'Underline',
    'StrikeThrough',
    '|',
    'FontName',
    'FontSize',
    'FontColor',
    'BackgroundColor',
    '|',
    'SubScript',
    'SuperScript',
    '|',
    'LowerCase',
    'UpperCase',
    '|',
    'Formats',
    'Alignments',
    '|',
    'OrderedList',
    'UnorderedList',
    '|',
    'Indent',
    'Outdent',
    '|',
    'CreateLink',
    'Image',
    '|',
    'ClearFormat',
    'Print',
    'SourceCode',
    '|',
    'FullScreen',
  ],
};

// demo data
document_types: any[] = [
  {
    document_id: '1',
    document_type_id: '1',
    document_name: 'Process Instructions',
    document_description: '',
    document_template_file: 'template.docx',
    name_file: 'PS_Instructions',
  },
  {
    document_id: '2',
    document_type_id: '1',
    document_name: 'Process Instructions Combined',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'PSC_Instructions',
  },
  {
    document_id: '3',
    document_type_id: '1',
    document_name: 'Field Call Instructions',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'FC_Instructions',
  },
  {
    document_id: '4',
    document_type_id: '1',
    document_name: 'Field Call Instructions Combined',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'FCC_Instructions',
  },
  {
    document_id: '5',
    document_type_id: '1',
    document_name: 'Enforcement Hearing Instructions',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'EH_Instructions',
  },
  {
    document_id: '6',
    document_type_id: '1',
    document_name: 'Occupancy Check Intructions',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'OC_Instructions',
  },
  {
    document_id: '7',
    document_type_id: '1',
    document_name: 'Lockout Instructions',
    document_description: '',
    document_template_file: 'template.doc',
    name_file: 'Lockout_Instructions',
  },
];
subject_template_docs: any;
sent_subject_job_type_id: any;
sent_subject_com_type_id: any;
model: SubjectCommunication;
created_file_name: string;
tableData: any;
tableSubjectData: any;
get_latest_subject_note_id: any;
job_types: any;
job_subject_types: any;
job_plaintiff_types: any;
job_type_locations: any;
count2: any;
job_type_courts: any;
sent_job_type_location_id: any;
job_type_document_types: any;
sent_job_type_court_id: any;
job_type_affidavit_types: any;
sent_job_type_document_type_id: any;
doc_check: any;
assignedList: any;
assignedBrandList: any;
assignedBrandListDD: any;

subjectFullNameOrBusiness: any;

// iframe
name = 'Set iframe source';
url: string = 'https://angular.io/api/router/RouterLink';
urlSafe: SafeResourceUrl;
job_data: any;
brand_data: any;
recipient_brand_id: any;
accounts_brand_id: any;
brand_account_data: any;
brand_user_data: any;
email_template_name: any;
html_data: string;
url_non_ssl: string;
recipient_report_id: any;
email_template_HTML: any;
brand_report_id: any;
brand_invoice_id: any;
primary_contacts: any;
filemodel: SystemFile;
file_created_response: any;
sessionUserLevel: any;
system_log_created_response: any;
file_edit_level: string;
returned_created_file_id: any;
subject_invoices: any;
  subject_number: any;
  set_job_type_name: any;
  set_job_type_location_name: any;
  set_job_type_court_name: any;
  set_job_type_document_type_name: any;
  set_job_type_affidavit_type_name: any;
  brand_type: any;
  brand_type_name: any;
  subject_com_type: any;
  subject_com_type_name: any;
  job_type_court: any;
  court_name: any;
  job_type_location: any;
  location_name: any;
  job_type_document: any;
  document_type_name: any;
  job_type_affidavit: any;
  affidavit_type_name: any;
  job_type: any;
  job_type_name: any;


   // access the template form
   @ViewChild('subjectForm') subjectForm: NgModel;
   @Input() show_send_email_options;
  current_invoice_id: any;
  agent_brand: any;
  invoice_brand: any;
  subject_work_orders: any;
  current_work_order_id: any;
  current_work_order_agent_id: any;
  subject_communication_history_created_response: any;
  assignedAgentsList: any;
  allRecipients: any;
  allAgentRecipients: any;
  assignedAgentsList2: any;
  sessionUsername: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;
  set_document_password: string;
  is_encrypted: number;
  creating_file: number;
  isShow_AdvancedOptions = false;
  legalDatePickerValues: { [field: string]: Date | null } = {};



constructor(
  private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  vcr: ViewContainerRef,
  private router: Router,
  public HttpClient: HttpClient,
  private fileUploader: FileUploaderService,
  private _mysqlService: MysqlService, 
  private modalService: BsModalService,
  private _location: Location,
  public sanitizer: DomSanitizer,
  public gfunc: GlobalFunctionsService,
  public legalDate: LegalDateTimeService
) {

  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
      this.sessionUserFullName = this.gfunc.currentUserVAR.first_name + ' ' + this.gfunc.currentUserVAR.surname;
      this.sessionUserFirstName = this.gfunc.currentUserVAR.first_name;

    //  this.toastr.setRootViewContainerRef(vcr);

    this.creating_file = 0; // creating file animation and progress

    this.isShow = true;
this.isShow_uploaded = true;
this.show_send_email_options = false;

 }

// check for changes. to load data.
ngOnChanges(changes) {
 if (changes.item_id) {
   // deal with asynchronous Observable result
   this.subject_id = changes.item_id.currentValue;

  this.filemodel = new SystemFile();

  this.modelds = new SubjectCommunicationAttatchments();
  this.model = new SubjectCommunication();
  this.legalDatePickerValues = {};

 


  this.model.attached_file_name = '';
  this.getJobSubject(this.subject_id);
  this.getJobStatusNames();
  this.getSubjectComTypes();



// :: if set from parrent component
// this.model.subject_com_type_id = 3;
// this.sent_subject_com_type_id = 3;
// this.subjectForm.control['subject_com_type_id'].setValue('3'); // Client Communication


// loads the template docs based in client communication
// this.sendSubjectComTypeID(3);
// this.model.subject_com_type_id = 3;
// this.sent_subject_com_type_id= 3;
// this.model.doc_id = 20;
// this.doc_check = undefined;

 }
}


ngOnInit() {
}

private getAuditTimestamp(): string {
  return this.legalDate.nowAuditIso();
}

getLegalDatePickerValue(model: any, field: string): Date | null {
  return this.legalDatePickerValues[field] ?? this.legalDate.toPickerDate(model?.[field]);
}

onLegalDateChange(model: any, field: string, value: unknown): void {
  const pickerDate = this.legalDate.coercePickerDate(value);
  this.legalDatePickerValues[field] = pickerDate;
  model[field] = this.legalDate.fromPickerDate(pickerDate);
}

// Functions

getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
    (data) => {
      this.subjects = data;
      const res = data[0];
      this.getSubjectNotes(res.subject_id);
      // load subject history
      // this.getSubjectProgress(res.job_id, res.file_number);

      // set the subject name
      if (res.business_name !== '' || res.business_name !== null) {
        this.subjectFullNameOrBusiness = res.business_name;
      }

      if (res.business_name === '' || res.business_name === null) {
        this.subjectFullNameOrBusiness = res.first_name + ' ' + res.surname;
      }

      this.job_id = res.job_id;
      this.subject_number = res.subject_number;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

      this.getJobTypeLocations(res.job_type_id);
      this.getJobTypeCourts(res.job_type_location_id);
      this.getJobTypeDocumentTypes(res.job_type_court_id);
      this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      this.getJobTypes();
      this.getSubjectAgentBrandsAssigned(this.subject_id);

      // get the job data to get the brand to send to
      this.getJob(this.job_id);
      this.getSubjectInvoices(this.subject_id);
     
      // :: Agent Work Orders
     // this.getSubjectAgentWorkOrders(this.subject_id, this.current_work_order_agent_id);

     // secuirty agents assign_to_agents
       // set the agent permissions
      this.getSubjectAgentBrandsAssigned_comms(this.subject_id);

      // get job type in relation to subject
      // this.getJobType(res.job_type_id);
      // this.getJobTypeLocation(res.job_type_location_id);
      // this.getJobTypeCourt(res.job_type_court_id);
      // this.getJobTypeDocument(res.job_type_document_type_id);
      // this.getJobTypeAffidavit(res.job_type_affidavit_type_id)
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    (data) => {
      this.subject_notes = data;
      // console.log("Done loadng USER");
      // console.log(this.users);
    },
    (error) => {
      //  console.error('Error Loading User!');
      // return error.error;
    }
  );
}

private getJobStatusNames() {
  this._demoService.getJobStatusNames().subscribe(
    (res) => (this.job_status_run = res),
    (err) => console.error(err.status)
  );
}

private getSubjectComTypes() {
  this._demoService.getSubjectComTypes().subscribe(
    (res) => (this.subject_com_types = res),
    (err) => console.error(err.status)
  );
}

sendSubjectComTypeID(subject_com_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_subject_com_type_id = subject_com_type_id;
  this.getSubjectTemplateDocs(this.sent_subject_com_type_id); // updates the selected job ID....
  console.log(this.sent_subject_com_type_id);
}

private getSubjectTemplateDocs(subject_com_type_id) {
  this._demoService.getSubjectTemplateDocsMenu(subject_com_type_id).subscribe(
    (res) => (this.subject_template_docs = res),
    (err) => console.error(err.status)
  );
}

// private getSubjectTemplateDocs(subject_com_type_id) {
//   this._demoService.getSubjectTemplateDocs(subject_com_type_id).subscribe(
//     (res) => (this.subject_template_docs = res),
//     (err) => console.error(err.status)
//   );
// }


subjectView2(subject_id) {
  this.router
    .navigateByUrl('admin/clients', { skipLocationChange: true })
    .then(() =>
      this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + ''])
    );

  // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectCommunication(subject_id) {
  this.router.navigate([
    '/admin/jobs/subject/communication/' + subject_id + '',
  ]);
}

subjectDocuments(subject_id) {
  this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
}

subjectNotesTab(subject_id) {
  this.router.navigate(['/admin/jobs/subject/notes/' + subject_id + '']);
}

// need to get the file id from the response
createDocument(model) {
 // this._mysqlService.createDocument(model).subscribe(
  this._mysqlService. createDocument_2021Test(model).subscribe(
 (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      
      // Need to get JSON object returned with the password from APP_PHP.
      this.created_file_name = res[0] as string;




      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      // need to 


      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via subject communcation UI',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.sessionUserId,
        created_date: this.getAuditTimestamp(),
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: 'TESTING',
        // file_password: this.set_document_password,
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.gfunc.sessionUserId,
        updated_date: this.getAuditTimestamp(),
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: this.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        report_access_array: JSON.stringify(this.brand_data), // collect client
        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        is_theme: model.is_theme,
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
      return error.error;
    }
  );
}

sendAgentInstructEmail(model) {
  // model.attached_file_name = this.created_file_name;
  model.attached_file_names = this.selectedFeatures;
  model.attached_job_file_names = this.selectedFeaturesJobFiles;
  model.allAttachments = this.allAttachments;
  console.log(model.attached_file_names);

  this.createSubjectNote(model); // Insert a Note to the subject

  this._mysqlService.sendAgentInstructEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string

    },
    (error) => {
      // this.toastr.error('Error sending Email');
      return error.error;
    }
  );
}

// this function is universal for client or email now.
sendAgentCommunicationEmail(model) {
  // model.attached_file_name = this.created_file_name;
  model.attached_file_names = this.selectedFeatures;
  model.attached_job_file_names = this.selectedFeaturesJobFiles;
  model.all_attached_file_names = this.allAttachedFiles;
  model.allAttachments = this.allAttachments;
  console.log(model.attached_file_names);

  this.model.allAttachments = this.allAttachments;

  this.createSubjectNote(model); // Insert a Note to the subject

  const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
  console.log('Communication Type Task: ' +  subject_com_type_name);
      //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
       //  console.log('Communication Type Task: ' +  subject_com_type_name);
 const doc_name = document.getElementById('doc_name').innerText;
 console.log('Document Name: ' +  doc_name);

  // set the invoice from the list of invoices (first record)
  if(model.invoice_id == null){
    model.invoice_id = this.current_invoice_id;
  }

  if(model.work_order_id == null){
    model.work_order_id = this.current_work_order_id;
  }


  // upgrade create Communication History
  // const log_action = 'sent';
  // const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
  const subject_communication_history = {
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_com_type_id: model.subject_com_type_id,
    doc_id: model.doc_id,
    change_dates: model.change_dates,
    additional_message: model.additional_message,
    brand_type_id: model.brand_type_id,
    brand_id: model.brand_id,
    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
    send_to_invoice: model.send_to_invoice,
    send_to_report: model.send_to_report,
    send_to_logins: model.send_to_logins,
    send_to_primary: model.send_to_primary,
    allAttachments: JSON.stringify(model.allAttachments),
    allRecipients: JSON.stringify(model.allRecipients),
    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
    brand_report_id: model.brand_report_id,
    brand_invoice_id: model.brand_invoice_id,
    job_type_name: model.job_type_name,
    job_type_location_name: model.job_type_location_name,
    brand_report_user_id: model.brand_report_user_id,
    email_message_subject: model.email_message_subject,
    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
    message_subject: model.message_subject,
    recipient_name: model.recipient_name,
    recipient_type_name: model.recipient_type_name,
    recipient_email_address: JSON.stringify(model.recipient_email_address),
    email_template_HTML: model.email_template_HTML,
    subject_number: model.subject_number,
    created_by: this.sessionUserId,
    created_date: this.getAuditTimestamp(),
    attached_file_names: JSON.stringify(model.attached_file_names),
    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
    subject_com_type_name: model.subject_com_type_name
  };
  this.gfunc.createSubjectCommunicationHistory(subject_communication_history);



  const log_action = 'sent';
  const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.getAuditTimestamp(),
    subject_id: this.subject_id,
    job_id: this.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
    brand_type_id: model.brand_type_id,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
    agent_id: model.agent_id,
  };
  this.createSystemLog(create_sys_log);
        // Update invoice status
        // :: @ Update the Invoice Status to Approved+PDF (4)   
        let invoice_model = {
          invoice_id: model.invoice_id,
          invoice_communication_status_id: 2,
            }; 
   
          this.updateInvoiceCommunicationStatus(invoice_model);
    

          let work_order_model = {
            work_order_id: model.work_order_id,
            work_order_communication_status_id: 2,
              }; 
     
            this.updateWorkOrderCommunicationStatus(work_order_model);
              

  this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
   //   console.log(res); // not working as response is showing in body
      // console.log(res._body);
   //   console.log(res[0].text()); // Convert response to a string


// now close the modal
this.closeParentModel.emit();
this.closeParentModel3.emit();
// refresh the invoice page if
if ( model.invoice_id > 0 ){
  this.refreshSujectInvoicePage.emit(this.subject_id);
}
if ( model.work_order_id > 0 ){
  this.refreshSujectWorkOrderPage.emit(this.subject_id);
}

    },
    (error) => {
      // this.toastr.error('Error sending Email');
      return error.error;
    }
  );
}

// this function is universal for client or email now.
sendAffidavitCommunicationEmail(model) {
  // model.attached_file_name = this.created_file_name;
  model.attached_file_names = this.selectedFeatures;
  model.attached_job_file_names = this.selectedFeaturesJobFiles;
  model.all_attached_file_names = this.allAttachedFiles;
  model.allAttachments = this.allAttachments;
  console.log(model.attached_file_names);

  this.createSubjectNote(model); // Insert a Note to the subject

  this.model.allAttachments = this.allAttachments;

  this._mysqlService.sendAffidavitCommunicationEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
    },
    (error) => {
      // this.toastr.error('Error sending Email');
      return error.error;
    }
  );
}

sendClientAttServEmail(model) {
  // model.attached_file_name = this.created_file_name;
  model.attached_file_names = this.selectedFeatures;
  model.attached_job_file_names = this.selectedFeaturesJobFiles;
  model.allAttachments = this.allAttachments;
  console.log(model.attached_file_names);

  this.createSubjectNote(model); // Insert a Note to the subject

  this._mysqlService.sendClientAttServ(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
    },
    (error) => {
      // this.toastr.error('Error sending Email');
      return error.error;
    }
  );
}

private refreshList(): void {
  // notice the update here for traces
  this.fileUploader
    .getJobFiles(this.job_id)
    .subscribe((res) => this.displayTableData(res));
}
// job_id(job_id: any): any {
//   throw new Error('Method not implemented.');
// }

displaySubjectDocuments(subject_id, subject_number) {
  this.fileUploader
    .getJobSubjectFiles(this.subject_id, this.subject_number)
    .subscribe((res) => this.displaySubjectFiles(res));
}
// subject_number(subject_id: number, subject_number: any): any {
//   throw new Error('Method not implemented.');
// }

private displayTableData(data: any): void {
  // this.tableData = data.json();
  this.tableData = data
}

private displaySubjectFiles(data: any): void {
  // this.tableSubjectData = data.json();
  this.tableSubjectData = data
}

attachFile(filename, job_id) {
  if (confirm('Are you sure you want to Attatch this file? ')) {
    /*
      this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
         data => {
           // this.getTraceNotes(this.trace_id);
          this.refreshList();
           return true;
         },
         error => {
           console.error('Error deleting Job File!');
           return error.error;
         }
      );*/

    this.model.attached_file_names = filename;

    console.log(filename);
  }
}

attachJobFile(filename, job_id) {
  if (confirm('Are you sure you want to Attatch this file? ')) {
    /*
      this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
         data => {
           // this.getTraceNotes(this.trace_id);
          this.refreshList();
           return true;
         },
         error => {
           console.error('Error deleting Job File!');
           return error.error;
         }
      );*/

    this.model.attached_job_file_names = filename;
    // console.log(filename);
  }
}

deleteJobFile(filename, job_id) {
  if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFile(filename, job_id).subscribe(
      (data) => {
        // this.getTraceNotes(this.trace_id);
        this.refreshList();
        return true;
      },
      (error) => {
        console.error('Error deleting Job File!');
        return error.error;
      }
    );
  }
}

onAdd(fileName) {
  if (confirm('Are you sure you want to Attatch this file? ')) {
    this.selectedFeatures.push(fileName);
    // push to global array
    this.allAttachedFiles.push(fileName);
    this.allAttachments.push({
      file_name: fileName,
      job_file: 0,
      subject_file: 1,
    });

    // this.toastr.success('Attatchment added.');
    this.isShow = !this.isShow; // hides the div again
    // this.isShow_uploaded = !this.isShow_uploaded;
  }
}

onAddJobFile(fileName) {
  if (confirm('Are you sure you want to Attatch this file? ')) {
    this.selectedFeaturesJobFiles.push(fileName);
    // push to global array
    this.allAttachedFiles.push(fileName);
    this.allAttachments.push({
      file_name: fileName,
      job_file: 1,
      subject_file: 0,
    });
    // this.toastr.success('Attatchment added.');
    // this.isShow = !this.isShow; // hides the div again
    this.isShow_uploaded = !this.isShow_uploaded;
  }
}

onRemoveJobFile() {
  this.selectedFeaturesJobFiles.pop();
  // this.toastr.warning('Attatchment removed.');
}

onRemoveAllFile() {
  this.allAttachedFiles.pop();
  // this.toastr.warning('Attatchment removed.');
  // this.allAttachments.pop();
}

onRemove() {
  this.selectedFeatures.pop();
  // this.toastr.warning('Attatchment removed.');
}

// toggle elements
toggleDisplay() {
  this.isShow = !this.isShow;
}

toggleDisplayUploaded() {
  this.isShow_uploaded = !this.isShow_uploaded;
}

// Create New Type of note:
createSubjectNote(model) {
  // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
  model.created_by = this.sessionUserId;
  model.note_content =
    'Instruct request emailed to the agent. Manual From Subject Card Screen.';
  model.note_type_id = '1';
  // if (result.job_status === 'OPEN'){
  this._demoService.createSubjectNote(model).subscribe(
    (data) => {
      this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
      // this.toastr.info('Note Added To Subject!');
      // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
      // this.search_results[objIndex].note_added = 'yes';
    },
    (error) => {
      // console.log(Observable.throw(error));
      return error.error;
    }
  );
  // } // end if  open
}

// BOF SHARMANS CALLS
getJobTypes() {
  this._demoService.getJobTypes().subscribe(
    (data) => {
      this.job_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobSubjectTypes() {
  this._demoService.getJobSubjectTypes().subscribe(
    (data) => {
      this.job_subject_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobPlaintiffTypes() {
  this._demoService.getJobPlaintiffTypes().subscribe(
    (data) => {
      this.job_plaintiff_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobTypeLocations(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
    (data) => {
      this.job_type_locations = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeLocationsID(job_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count2 = job_type_id;
  this.getJobTypeLocations(this.count2); // updates the selected job ID....

  console.log('sending Count:' + this.count2);
}

getJobTypeCourts(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
    (data) => {
      this.job_type_courts = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeCourtsID(job_type_location_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_location_id = job_type_location_id;
  this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....

  console.log('sending Location:' + this.sent_job_type_location_id);
}

getJobTypeDocumentTypes(job_type_court_id) {
  this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
    (data) => {
      this.job_type_document_types = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

sendJobTypeDocumentTypesID(job_type_court_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_court_id = job_type_court_id;
  this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

  console.log('sending Court Type:' + this.sent_job_type_court_id);
}

getJobTypeAffidavitTypes(job_type_document_type_id) {
  this._demoService
    .getJobTypeAffidavitTypes(job_type_document_type_id)
    .subscribe(
      (data) => {
        this.job_type_affidavit_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
}

sendJobTypeAffidavitTypesID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_document_type_id = job_type_document_type_id;
  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

  console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}

getSubjectTemplateDocsCheck(model) {
  this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
    (data) => {
      {
        this.doc_check = data;
        const res = data[0];
        // set the model document id to the new one affidavits.
        model.doc_id = res.doc_id; // does this need to be this.???
        // set the recipeint type for display
        model.brand_type_id = res.brand_type_id;

        this.email_template_name = res.email_template;
        this.email_template_HTML = res.email_template_HTML;
        model.send_to_invoice = res.send_to_invoice;
        model.send_to_report = res.send_to_report;
        model.send_to_logins = res.send_to_logins;
        model.send_to_primary = res.send_to_primary;
        model.brand_type_id = res.brand_type_id;


               // advanced_options 2024
               model.is_theme = res.is_theme;
               model.encrypt_file = res.encrypt_file;
               model.render_images = res.render_images;
               model.render_images_empties = res.render_images_empties;

        // load the recipients into an array
        this.getSubjectAgentBrandsAssigned(this.subject_id);
        // load brands - clients into array
        this.getBrand(this.recipient_report_id);
        this.getBrandUsers(this.recipient_report_id);
        this.getBrandAccount(this.accounts_brand_id);

        model.brand_report_id = this.brand_report_id;
        model.brand_invoice_id = this.brand_invoice_id;

        model.change_dates = '0'; // set to default to system dates changes
        this.created_file_name = null; // reset the file to be recreated on change

        this.url =
        this.gfunc.baseUploadURLEmailTemplatesSSL +
          this.email_template_name;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.url
        );
      }
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

// to router navigate back
public goBack() {
  this._location.back();
}

docView(doc_id) {
  this.router.navigate([
    '/admin/communication/com_type_template_doc_view/' + doc_id + '',
  ]);
}

docEdit(doc_id) {
  this.router.navigate([
    '/admin/communication/com_type_template_doc_edit/' + doc_id + '',
  ]);
}


docEditSubjectFile(file_id) {
  this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
}

docViewSubjectFile(file_id) {
  this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
}

// viewSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
// }

// editSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
// }

// editDocFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
// }


// editDocxSystemFile(file_id) {
//   this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
// }


viewDocxSystemFile(file_id) {
//  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  this.gfunc.globalViewDocxSystemFile(file_id);
}
  


subjectEditLink(subject_id) { 
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
}


viewSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  this.gfunc.globalViewSystemFile(file_id);
}

editSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  this.gfunc.globalEditSystemFile(file_id);
}

editDocFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  this.gfunc.globalEditDocFile(file_id);
}


editDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  this.gfunc.globalEditDocxSystemFile(file_id);
}



// testing some jquery
Testing() {
  const name = (
    document.getElementById('subject_com_type_id') as HTMLTextAreaElement
  ).value;
  alert(name);

  // get the option name of the select Works so can use when adding as a fix.
  const conceptName = $('#subject_com_type_id').find(':selected').text();
  const conceptNameID = $('#subject_com_type_id').find(':selected').val();
  alert(conceptNameID + ':-  ' + conceptName);
}

// lookup and then set the doc_check array with the data.
getSubjectTemplateDoc(model) {
  this._demoService.getSubjectTemplateDoc(model.doc_id).subscribe(
    (data) => {
      this.doc_check = data;
      const res = data[0];
      // load the drop downs res.doc_ii
      // set the model document id to the new one affidavits.
      model.doc_id = res.doc_id;
      // set the recipeint type for display
      model.brand_type_id = res.brand_type_id;
      this.email_template_name = res.email_template;
      this.email_template_HTML = res.email_template_HTML;
      model.send_to_invoice = res.send_to_invoice;
      model.send_to_report = res.send_to_report;
      model.send_to_logins = res.send_to_logins;
      model.send_to_primary = res.send_to_primary;
      model.brand_type_id = res.brand_type_id;

      model.brand_report_id = this.brand_report_id;
      model.brand_invoice_id = this.brand_invoice_id;

       // advanced_options 2024
       model.is_theme = res.is_theme;
       model.encrypt_file = res.encrypt_file;
       model.render_images = res.render_images;
       model.render_images_empties = res.render_images_empties;


      // load the recipents into an array
      this.getSubjectAgentBrandsAssigned(this.subject_id);
      this.getSubjectAgentBrandsAssignedDD(this.subject_id); // loads the drop down.
      // load brands - clients into array
      this.getBrand(this.recipient_report_id);
      this.getBrandUsers(this.recipient_report_id);
      this.getBrandAccount(this.accounts_brand_id);

      model.change_dates = '0'; // set to default to system dates changes
      this.created_file_name = null; // reset the file to be recreated on change
      // iframe

      this.url =
      this.gfunc.baseUploadURLEmailTemplatesSSL +
        this.email_template_name;
      this.url_non_ssl =
      this.gfunc.baseUploadURLEmailTemplates +
        this.email_template_name;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

      // upgrade for attempts paragraphs checker == if 1 then accept. otherwise warn
      // 2.3.1.1
      model.attempt_paragraph_template = res.attempt_paragraph_template;
      

      //   This DID NOT WORK!  CORS ACCESS ISSUES (will only work online? no cors)
      // HAD TO SETUP SERVER TO ALLOW ACCESS PLESK
      // see:  https://support.plesk.com/hc/en-us/articles/115001338265-How-to-set-up-CORS-cross-origin-resource-sharing-in-Plesk-for-Linux-

      //   if(this.email_template_name != null) {
      //   // get email temlate file as a variable TESTING
      //   fetch(this.url)
      //   .then(response => response.text())
      //   .then(html_data => {
      //   	// Do something with your data
      //     this.html_data = html_data;
      //   	console.log(html_data);
      //   });
      //   // end fetch
      // } // end if no template set
    },
    (err) => console.error(err),
    () => console.log('')
  );
}

private getBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.brand_data = data;

      this.allClientEmailRecipients = data;
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}

private getBrandAccount(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.brand_account_data = data;

      this.allClientInvoiceEmailRecipients = data;
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}

getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
    (data) => {
      this.brand_user_data = data;

      this.allLoginEmailRecipients = data;
    },
    (err) => console.error(err),
    () => console.log('Candidates Loaded.')
  );
}

// get job
getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
    (data) => {
      this.job_data = data;
      let res = data[0];
      // lookup the brand to get the contact details to send to
      this.recipient_brand_id = res.brand_report_id;
      this.recipient_report_id = res.brand_report_id;
      this.accounts_brand_id = res.brand_invoice_id;
      this.getBrand(res.brand_report_id);
      this.getBrandAccount(res.brand_invoice_id);
      this.getBrandUsers(res.brand_report_id);
      this.getBrandPrimaryContact(this.recipient_report_id);

      this.brand_report_id = res.brand_report_id;
      this.brand_invoice_id = res.brand_invoice_id;

      //this.model.brand_id = this.recipient_brand_id;
      ///console.log('check brand' + this.recipient_brand_id);
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
    (data) => {
      this.assignedBrandList = data;

    //  this.allEmailRecipients = data;
    },
    (err) => console.error(err),
    // () => console.log('Loaded Assigned Agents Loaded.')
  );
}

getUrl(post, email_template) {
  return this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://' + post + '/' + email_template
  );
}


// need to get user details
getBrandPrimaryContact(brand_id) {
this._demoService.getBrandPrimaryContact(brand_id).subscribe(
   data => { this.primary_contacts = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}

// Removes Email From Main List. (by ID's)

RemoveElementFromAllEmailRecipients(key: number) {
  // removes agents
  this.allEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allEmailRecipients.splice(index, 1);
    }
  });
  // removes clients Report
  this.allClientEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allClientEmailRecipients.splice(index, 1);
    }
  });
  // removes clients Invoice
  this.allClientInvoiceEmailRecipients.forEach((value, index) => {
    if (value.brand_id === key) {
      this.allClientInvoiceEmailRecipients.splice(index, 1);
    }
  });
  // removes Login Users
  this.allLoginEmailRecipients.forEach((value, index) => {
    if (value.user_id === key) {
      this.allLoginEmailRecipients.splice(index, 1);
    }
  });

  // removes all attachments
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
    }
  });
}

// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}



createFile(model){
  this._demoService.createFile(model).subscribe(
    data => { this.file_created_response = data;
    // need to get the returned ID to send to log create action
  
    this.returned_created_file_id = this.file_created_response.last_insert_id;
    console.log(this.returned_created_file_id);


    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name);
   
   const log_action = 'created';
   const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ''; 
   
   let create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.getAuditTimestamp(),
    subject_id: this.subject_id,
    job_id: this.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: 1, // see datatable system_log_types
    created_level: this.sessionUserLevel,
    brand_type_id: model.brand_type_id,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
  };


  // We need to brea this up into the commnuication types and ceate sepearte logs for each of these
 //  this.createSystemLog(create_sys_log); // retired to sepeate functions....

 //  Client Report Communication
  if(model.subject_com_type_id == 3 ){
   let _log_type_id = 67
    create_sys_log = {
     log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
     log_action: log_action, // automated / updated / created / uploaded / link_created / sent
     created_by: this.sessionUserId,
     created_date: this.getAuditTimestamp(),
     subject_id: this.subject_id,
     job_id: this.job_id,
     job_reference_number: model.job_reference_number,
     file_number: model.file_number,
     reference_number: model.job_reference_number,
     subject_number: model.subject_number,
     log_type_id: _log_type_id, // see datatable system_log_types
     created_level: this.sessionUserLevel,
     brand_type_id: model.brand_type_id,
     subject_com_type_id: model.subject_com_type_id,
     subject_template_doc_id: model.doc_id,
     log_name: log_name + ' - ' + this.returned_created_file_id,
     file_id: this.returned_created_file_id,
     invoice_id: model.invoice_id,
   };
   this.createSystemLog(create_sys_log);
  }

 //  Affidavit Creation - Communications
 if(model.subject_com_type_id == 4 ){
 let _log_type_id = 68
   create_sys_log = {
   log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
   log_action: log_action, // automated / updated / created / uploaded / link_created / sent
   created_by: this.sessionUserId,
   created_date: this.getAuditTimestamp(),
   subject_id: this.subject_id,
   job_id: this.job_id,
   job_reference_number: model.job_reference_number,
   file_number: model.file_number,
   reference_number: model.job_reference_number,
   subject_number: model.subject_number,
   log_type_id: _log_type_id, // see datatable system_log_types
   created_level: this.sessionUserLevel,
   brand_type_id: model.brand_type_id,
   subject_com_type_id: model.subject_com_type_id,
   subject_template_doc_id: model.doc_id,
   log_name: log_name + ' - ' + this.returned_created_file_id,
   file_id: this.returned_created_file_id,
   invoice_id: model.invoice_id,
 };
 this.createSystemLog(create_sys_log);
 }

       //  Agent Creation - Communications
         if(model.subject_com_type_id == 2 ){
           let _log_type_id = 69
             create_sys_log = {
             log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
             log_action: log_action, // automated / updated / created / uploaded / link_created / sent
             created_by: this.sessionUserId,
             created_date: this.getAuditTimestamp(),
             subject_id: this.subject_id,
             job_id: this.job_id,
             job_reference_number: model.job_reference_number,
             file_number: model.file_number,
             reference_number: model.job_reference_number,
             subject_number: model.subject_number,
             log_type_id: _log_type_id, // see datatable system_log_types
             created_level: this.sessionUserLevel,
             brand_type_id: model.brand_type_id,
             subject_com_type_id: model.subject_com_type_id,
             subject_template_doc_id: model.doc_id,
             log_name: log_name + ' - ' + this.returned_created_file_id,
             file_id: this.returned_created_file_id,
             invoice_id: model.invoice_id,
           };
           this.createSystemLog(create_sys_log);
           }    

       //  Agent Instruct Creation - Communications
       if(model.subject_com_type_id == 1 ){
         let _log_type_id = 70
           create_sys_log = {
           log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
           log_action: log_action, // automated / updated / created / uploaded / link_created / sent
           created_by: this.sessionUserId,
           created_date: this.getAuditTimestamp(),
           subject_id: this.subject_id,
           job_id: this.job_id,
           job_reference_number: model.job_reference_number,
           file_number: model.file_number,
           reference_number: model.job_reference_number,
           subject_number: model.subject_number,
           log_type_id: _log_type_id, // see datatable system_log_types
           created_level: this.sessionUserLevel,
           brand_type_id: model.brand_type_id,
           subject_com_type_id: model.subject_com_type_id,
           subject_template_doc_id: model.doc_id,
           log_name: log_name + ' - ' + this.returned_created_file_id,
           file_id: this.returned_created_file_id,
           invoice_id: model.invoice_id,
         };
         this.createSystemLog(create_sys_log);
         } 


     //  Owner Instruct Creation - Communications
       if(model.subject_com_type_id == 5 ){
         let _log_type_id = 71
           create_sys_log = {
           log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
           log_action: log_action, // automated / updated / created / uploaded / link_created / sent
           created_by: this.sessionUserId,
           created_date: this.getAuditTimestamp(),
           subject_id: this.subject_id,
           job_id: this.job_id,
           job_reference_number: model.job_reference_number,
           file_number: model.file_number,
           reference_number: model.job_reference_number,
           subject_number: model.subject_number,
           log_type_id: _log_type_id, // see datatable system_log_types
           created_level: this.sessionUserLevel,
           brand_type_id: model.brand_type_id,
           subject_com_type_id: model.subject_com_type_id,
           subject_template_doc_id: model.doc_id,
           log_name: log_name + ' - ' + this.returned_created_file_id,
           file_id: this.returned_created_file_id,
           invoice_id: model.invoice_id,
         };
         this.createSystemLog(create_sys_log);
         } 


    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

createSystemLog(model){
  this._demoService.createSystemLog(model).subscribe(
    data => { this.system_log_created_response = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

createSubjectCommunicationHistory(model){
  this._demoService.createSubjectCommunicationHistory(model).subscribe(
    data => { this.subject_communication_history_created_response = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getSubjectInvoices(subject_id){
  this._demoService.getSubjectInvoices(subject_id).subscribe(
    data => { this.subject_invoices = data;
    let res = data[0];
    this.current_invoice_id = res.invoice_id;
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



// :: Invoice Upgrades ( Create Invoice From List.)

createDocument_Invoice(model, mergeJobData, invoice_id) {
// generate more data first
this._mysqlService.createDocument_Invoice(model, invoice_id).subscribe(
  (data) => {
    // this.trace_candidate_update = data;
    // this.toastr.success('Creating Invoice.');
    const res = data;
    console.log(res); // not working as response is showing in body
    // console.log(res._body);
    // console.log(res[0].text()); // Convert response to a string
    // this.created_file_name = res[0].text();
    this.created_file_name = res[0] as string;
    model.attached_file_name = this.created_file_name;
    this.refreshList(); // loads the file list (diretory)
    this.displaySubjectDocuments(this.subject_id, this.subject_number);

// set the invoice from the list of invoices (first record)
if(invoice_id == null){
  invoice_id = this.current_invoice_id;
}

    // push to global array
    this.allAttachedFiles.push(this.created_file_name);

    // Start the new array of file
    // this.allAttachments.push(this.created_file_name);

    const pushed_file = {
      file_name: this.created_file_name,
      subject_file: 1,
      job_file: 0,
    }; // multidimentional array push
    // this.allAttachments.push(pushed_file); // old way only works for an array.

    // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
    // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
    this.allAttachments.push({
      file_name: this.created_file_name,
      job_file: 0,
      subject_file: 1,
    });
    model.allAttachments = this.allAttachments; // ?? this may be causing errors.

    // [{name: currencyName, amount: this.ticker[currencyName].last} ]

    // Set the file locations
    //agent
   
    if (model.brand_type_id === '3') {
    this.file_edit_level = '5'; // agent can edit
    }
    //client
    if (model.brand_type_id === '2') {
      this.file_edit_level = '3'; // client cannot edit  (staff member can)
    }
    const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
    const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
    const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
    const file_name = this.created_file_name.slice(0, -5); // removes the extension
    const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
    // UPGRADE Document Model (Insert the File into the database)
    // File Json
    const create_file = {
      file_name: file_name,
      file_display_name: file_name,
      file_ext: 'pdf',
      file_server_location: file_server_location,
      file_url: file_url,
      file_folder: file_folder,
      file_make: 'created', // automated / updated / created / uploaded / link_created
      file_notes: 'File created via subject communcation UI',
      file_job_id: this.job_id,
      file_subject_id: this.subject_id,
      file_subject_number: this.subject_number,
      created_by: this.sessionUserId,
      created_date: this.getAuditTimestamp(),
      created_level: this.sessionUserLevel,
      file_brand_id: model.brand_report_id,
      file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
      is_active: '1',
      file_password: '',
      file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
      updated_by: '',
      updated_date: '',
      prev_file_id: '0',    // if updating
      brand_type_id: model.brand_type_id,  // if an agent or a client file
      subject_template_doc_id: model.doc_id,
      subject_com_type_id: model.subject_com_type_id,
      random_file_name: random_file_name,
      full_file_name: this.created_file_name,
      job_id: this.job_id,
      file_number: model.file_number,
      file_reference_number: model.file_reference_number,
      // arrays of sending to - based on subject_template_doc - setup
      agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
      report_access_array: JSON.stringify(this.brand_data), // collect client
      invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
      user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
      invoice_id: invoice_id,
      is_theme: model.is_theme,
    };
   // console.log( (JSON.stringify(this.assignedBrandList)) );
    this.createFile(create_file);

  // :: @ Update the Invoice Status to Approved+PDF (4)   
  let invoice_model = {
invoice_id: invoice_id,
invoice_status_id: 4,
  }; 
this.updateInvoiceStatus(invoice_model);

    // const log_content 
    // const log_action
    // Access DOM and get values from HTML template to send to logs
   // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
  // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
  // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
  // get the drop down value of text not id.



  },
  (error) => {
    // this.toastr.error('Error Creating Document');
    return error.error;
  }
);
}


updateInvoiceStatus(invoice_model){
  this._demoService.updateInvoiceStatus(invoice_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:

    },
    error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};



  updateInvoiceCommunicationStatus(invoice_model){
    this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the invoice:
      },
      error => {
       // console.error('Error saving Event!');
        // this.toastr.error('Error Changing Status of Subject');
        return console.error(error);
      }
     // err => console.error(err),
     //
    )};


    updateWorkOrderCommunicationStatus(work_order_model){
      this._demoService.updateWorkOrderCommunicationStatus(work_order_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
        },
        error => {
         // console.error('Error saving Event!');
          // this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};


createDocument_2021Test(model, mergeJobData,invoice_id) {
  // generate more data first



  this._mysqlService.createDocument_2021Test(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);


      this.set_document_password = res[1] as string;
      console.log('set_document_password: ' + this.set_document_password);

      if(model.encrypt_file == true){
        this.is_encrypted = 1; //  encrypted
      }else{
        this.is_encrypted = 0; // no encrypted
      }

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name); 
      
      
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

                          const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                          const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_name = this.created_file_name.slice(0, -5); // removes the extension
                          const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                          // UPGRADE Document Model (Insert the File into the database)
                          // File Json
                          const create_file = {
                            file_name: file_name,
                            file_display_name: file_name,
                            file_ext: 'docx',
                            file_server_location: file_server_location,
                            file_url: file_url,
                            file_folder: file_folder,
                            file_make: 'created', // automated / updated / created / uploaded / link_created
                            file_notes: 'File created via subject communcation UI',
                            file_job_id: this.job_id,
                            file_subject_id: this.subject_id,
                            file_subject_number: this.subject_number,
                            created_by: this.sessionUserId,
                            created_date: this.getAuditTimestamp(),
                            created_level: this.sessionUserLevel,
                            file_brand_id: model.brand_report_id,
                            file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                            is_active: '1',
                            file_password: this.set_document_password,
                            file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                            updated_by: '',
                            updated_date: '',
                            prev_file_id: '0',    // if updating
                            brand_type_id: model.brand_type_id,  // if an agent or a client file
                            subject_template_doc_id: model.doc_id,
                            subject_com_type_id: model.subject_com_type_id,
                            random_file_name: random_file_name,
                            full_file_name: this.created_file_name,
                            job_id: this.job_id,
                            file_number: model.file_number,
                            file_reference_number: model.file_reference_number,
                            // arrays of sending to - based on subject_template_doc - setup
                            agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                            report_access_array: JSON.stringify(this.brand_data), // collect client
                            invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                            user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                            is_theme: model.is_theme,
                            assigned_to_agents:  model.assigned_to_agents,  // set the agent permissions
                            is_encrypted: this.is_encrypted
                          };
                         // console.log( (JSON.stringify(this.assignedBrandList)) );
                          this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
            // console.log('there was an error' + JSON.stringify(error));
            // console.log('TextError.error: = ' + JSON.stringify(error.error.text));
            // this.created_file_name = error.error.text
      this.newCreatedFile(model, this.created_file_name);
    //  return error.error;
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}

// new with re response code being an error but returns and creatd the file... go fugure.???
newCreatedFile(model, created_file_name){


  model.attached_file_name = this.created_file_name;
  this.refreshList(); // loads the file list (diretory)
  this.displaySubjectDocuments(this.subject_id, this.subject_number);

  // push to global array
  this.allAttachedFiles.push(this.created_file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name); 
  
  
  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

  const pushed_file = {
    file_name: this.created_file_name,
    subject_file: 1,
    job_file: 0,
  }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  this.allAttachments.push({
    file_name: this.created_file_name,
    job_file: 0,
    subject_file: 1,
  });
  model.allAttachments = this.allAttachments; // ?? this may be causing errors.

  // [{name: currencyName, amount: this.ticker[currencyName].last} ]

  // Set the file locations
  //agent
 
  if (model.brand_type_id === '3') {
  this.file_edit_level = '5'; // agent can edit
  }
  //client
  if (model.brand_type_id === '2') {
    this.file_edit_level = '3'; // client cannot edit  (staff member can)
  }

                      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_name = this.created_file_name.slice(0, -5); // removes the extension
                      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                      // UPGRADE Document Model (Insert the File into the database)
                      // File Json
                      const create_file = {
                        file_name: file_name,
                        file_display_name: file_name,
                        file_ext: 'docx',
                        file_server_location: file_server_location,
                        file_url: file_url,
                        file_folder: file_folder,
                        file_make: 'created', // automated / updated / created / uploaded / link_created
                        file_notes: 'File created via subject communcation UI',
                        file_job_id: this.job_id,
                        file_subject_id: this.subject_id,
                        file_subject_number: this.subject_number,
                        created_by: this.sessionUserId,
                        created_date: this.getAuditTimestamp(),
                        created_level: this.sessionUserLevel,
                        file_brand_id: model.brand_report_id,
                        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                        is_active: '1',
                        file_password: '',
                        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                        updated_by: '',
                        updated_date: '',
                        prev_file_id: '0',    // if updating
                        brand_type_id: model.brand_type_id,  // if an agent or a client file
                        subject_template_doc_id: model.doc_id,
                        subject_com_type_id: model.subject_com_type_id,
                        random_file_name: random_file_name,
                        full_file_name: this.created_file_name,
                        job_id: this.job_id,
                        file_number: model.file_number,
                        file_reference_number: model.file_reference_number,
                        // arrays of sending to - based on subject_template_doc - setup
                        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                        report_access_array: JSON.stringify(this.brand_data), // collect client
                        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                        is_theme: model.is_theme,
                        assigned_to_agents:  model.assigned_to_agents  // set the agent permissions
                      };
                     // console.log( (JSON.stringify(this.assignedBrandList)) );
                      this.createFile(create_file);
}





createDocument_PHPDOocx(model, mergeJobData,invoice_id) {
  // generate more data first
  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

  this._mysqlService.createDocument_PHPDocx(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via New DocxAPI Merge Model',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.sessionUserId,
        created_date: this.getAuditTimestamp(),
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.gfunc.sessionUserId,
        updated_date: this.getAuditTimestamp(),
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: this.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        report_access_array: JSON.stringify(this.brand_data), // collect client
        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        is_theme: model.is_theme,
        assigned_to_agents:  model.assigned_to_agents
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
      return error.error;
    }
  );
}



// ::: !!! using a test PHP DOC !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// need to get the file id from the response
// Just send data that has already been loaded in JSON OBJECT ALREDAY.
generateMergeDocxJSON(model) {
  // console.log(model.json);
  // generate Additional Data to send to Docx Merge
  // get names and send to model
  // this.getBrandBrandType(model.brand_type_id);

  // this.getJobTypeLocation(model.job_type_location_id);
  // this.getJobType(model.job_type_id);
  // this.getJobTypeCourt(model.job_type_court_id);
  // this.getJobTypeDocument(model.job_type_document_type_id);
  // this.getJobTypeAffidavit(model.job_type_affidavit_type_id);

  
  
  }


pushInvoiceFileToSend(file_name){
      // push to global array
      this.allAttachedFiles.push(file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);
  
      const pushed_file = {
        file_name: file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.
  
      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: file_name,
        job_file: 0,
        subject_file: 1,
      });
     // this.model.allAttachments = this.allAttachments; // ?? this may be causing errors.

     console.log('File_name: ' + file_name);
}



setFileID(file_id){
  this.returned_created_file_id = file_id;
  console.log('file_id updated: ' + file_id)
};


// Agent Work Order

getSubjectAgentWorkOrders(subject_id, agent_id){
  this._demoService.getSubjectAgentWorkOrders(subject_id, agent_id).subscribe(
    data => { this.subject_work_orders = data;
    let res = data[0];
    this.current_work_order_id = res.work_order_id;
    this.current_work_order_agent_id = res.agent_id;



    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

 getInvoiceBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.invoice_brand = data;
      let res = data[0];


    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}


public getInvoiceAgentBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.agent_brand = data;
      let res = data[0];
      // this.agent_full_name = res.name;
      // this.work_order_model.agent_full_name = res.name;
      // this.invoiceForm.controls['agent_full_name'].setValue(this.agent_full_name); // sets the form value.
      // // set the to_brand_id // so we dont have to change for evertyning
      // this.work_order_model.to_brand_id = brand_id;
      // this.invoiceForm.controls['to_brand_id'].setValue(brand_id); // sets the form value.


    // set the recipient list in the send form ast the current agent.
    this.assignedBrandList = data;

    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}



createDocument_WorkOrder(model,work_order_id) {
  // generate more data first

  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

  this._mysqlService.createDocument_WorkOrder(model, work_order_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Work Order.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      this.created_file_name = res[0] as string;
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);
  
  // set the invoice from the list of invoices (first record)
  if(work_order_id == null){
    work_order_id = this.current_work_order_id;
  }
  
      // push to global array
      this.allAttachedFiles.push(this.created_file_name);
  
      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);
  
      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.
  
      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.
  
      // [{name: currencyName, amount: this.ticker[currencyName].last} ]
  
      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }
  
      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'pdf',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via subject communcation UI',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.sessionUserId,
        created_date: this.getAuditTimestamp(),
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.gfunc.sessionUserId,
        updated_date: this.getAuditTimestamp(),
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: this.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        report_access_array: JSON.stringify(this.brand_data), // collect client
        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        work_order_id: work_order_id,
        agent_id: model.agent_id,
        is_theme: model.is_theme,
        assigned_to_agents:  model.assigned_to_agents
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);
  
    // :: @ Update the Invoice Status to Approved+PDF (4)   




    let work_order_model = {
  work_order_id: work_order_id,
  work_order_status_id: 4,
    }; 
  this.updateWorkOrderStatus(work_order_model);
  
      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.
  
  
  
    },
    (error) => {
      // this.toastr.error('Error Creating Document');
      return error.error;
    }
  );
  }


  
updateWorkOrderStatus(work_order_model){
  this._demoService.updateWorkOrderStatus(work_order_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:

    },
    error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};


  getSubjectAgentBrandsAssignedDD(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
      (data) => {
        this.assignedBrandListDD = data;
  
      //  this.allEmailRecipients = data;
      },
      (err) => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned2(subject_id) {
  this.allRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
       this.model.assigned_to_agents = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};





// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
       this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



// Created to test and process new paragraph templates/merge variables Live without effecting original and current systems and workflows Live.
createDocument_2023_Paragraphs(model, mergeJobData,invoice_id) {
  // generate more data first

  // generate more data first
  this.creating_file = 1; // starts the file creating animation

  this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
    
      // generate more data first
  this.creating_file = 0; // ends the file creating animation
    
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);


      this.set_document_password = res[1] as string;
      console.log('set_document_password: ' + this.set_document_password);

      if(model.encrypt_file == true){
        this.is_encrypted = 1; //  encrypted
      }else{
        this.is_encrypted = 0; // no encrypted
      }

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name); 
      
      
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }


      // fix [0924_4_c]
      if(model.is_theme == undefined){
        model.is_theme = 0;
      }

                          const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                          const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_name = this.created_file_name.slice(0, -5); // removes the extension
                          const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                          // UPGRADE Document Model (Insert the File into the database)
                          // File Json
                          const create_file = {
                            file_name: file_name,
                            file_display_name: file_name,
                            file_ext: 'docx',
                            file_server_location: file_server_location,
                            file_url: file_url,
                            file_folder: file_folder,
                            file_make: 'created', // automated / updated / created / uploaded / link_created
                            file_notes: 'File created via subject communcation UI',
                            file_job_id: this.job_id,
                            file_subject_id: this.subject_id,
                            file_subject_number: this.subject_number,
                            created_by: this.gfunc.sessionUserId,
                            created_date: this.getAuditTimestamp(),
                            created_level: this.gfunc.sessionUserLevel,
                            file_brand_id: model.brand_report_id,
                            file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                            is_active: '1',
                            file_password: this.set_document_password,
                            file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                            updated_by: this.gfunc.sessionUserId,
                            updated_date: this.getAuditTimestamp(), // cannot be null anymore.
                            prev_file_id: '0',    // if updating
                            brand_type_id: model.brand_type_id,  // if an agent or a client file
                            subject_template_doc_id: model.doc_id,
                            subject_com_type_id: model.subject_com_type_id,
                            random_file_name: random_file_name,
                            full_file_name: this.created_file_name,
                            job_id: this.job_id,
                            file_number: model.file_number,
                            file_reference_number: model.file_reference_number,
                            // arrays of sending to - based on subject_template_doc - setup
                            agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                            report_access_array: JSON.stringify(this.brand_data), // collect client
                            invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                            user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                            is_theme: model.is_theme,
                            assigned_to_agents:  model.assigned_to_agents,  // set the agent permissions
                            is_encrypted: this.is_encrypted
                          };
                         // console.log( (JSON.stringify(this.assignedBrandList)) );




                          this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
            // console.log('there was an error' + JSON.stringify(error));
            // console.log('TextError.error: = ' + JSON.stringify(error.error.text));
            // this.created_file_name = error.error.text
      this.newCreatedFile(model, this.created_file_name);
    //  return error.error;
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}





}

// Allows formatting of dates etc...
export class DatePipeComponent {
today: number = Date.now();
fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
// tslint:disable-next-line:eofline
}
